import { render, staticRenderFns } from "./FileDropInput.vue?vue&type=template&id=1fae4660"
import script from "./FileDropInput.vue?vue&type=script&lang=js"
export * from "./FileDropInput.vue?vue&type=script&lang=js"
import style0 from "./FileDropInput.vue?vue&type=style&index=0&id=1fae4660&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports